module.exports = __webpack_public_path__ + "img/I-37.76544732.svg";